<template>
  <div id="app">
    <app-header></app-header>
    <router-view />
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import AppHeader from '@/components/layout/Header.vue';
import AppFooter from '@/components/layout/Footer.vue';
import Api from '@/services/api-service';

export default {
  name: 'home',
  components: {
    AppHeader,
    AppFooter
  },
  data () {
    return {
      interval: false,
      ignored_list: ['cart', 'favorites', 'thankyou', 'notify', '404', 'order', 'my-account', 'how-its-made']
    };
  },
  methods: {
    get_page () {
      if (this.ignored_list.indexOf(this.$route.name) === -1) {
        let t = this;
        t.$store.dispatch('fetchLoading', true);

        if (this.$store.state.app.page_params[this.$route.name]) {
          var page_params = this.$store.state.app.page_params[this.$route.name];
        } else {
          var page_params = [];
        }

        Api.post('/data/' + this.$route.name, {
          query: t.$route.query,
          params: t.$route.params,
          page_params: page_params
        })
          .then(response => {
            // eslint-disable-next-line eqeqeq
            if (response.status === 200) {
              if (response.data.navigation) {
                t.$store.dispatch('fetchNavigation', response.data.navigation);
              }
              t.$store.dispatch('fetchPage', response.data.page.response);
              if (this.interval) {
                clearInterval(this.interval);
              }
              this.interval = setTimeout(function () {
                t.$store.dispatch('fetchLoading', false);
              }, 1000);
            } else {
              this.$router.push({ name: '404' });
            }
          })
          .catch(error => {
            console.log('rrr', error);
            console.log('There was an error:', error.response);
          });
      }
    }
  },
  watch: {
    $route (to, from) {
      this.get_page();
    }
  },
  created () {
    this.get_page();
  }
};
</script>

<style lang="scss">
@import "assets/scss/app.scss";
</style>
